import {animate, state, style, transition, trigger} from '@angular/animations';
import {AfterViewInit, Component, ElementRef, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {createPopper, Instance as PopperInstance} from '@popperjs/core';
import {takeUntil} from 'rxjs/operators';
import {destroy$} from '../destroyable';
import {FLASH_MESSAGE_ANIMATION_TIME, FlashMessage, FlashMessageWidthType} from './flash-message';

enum VisibilityState {
    in = 'in',
    leave = 'leave'
}

const sizeClasses = {
    [FlashMessageWidthType.SMALL]: '-small-width',
    [FlashMessageWidthType.NORMAL]: '-normal-width',
    [FlashMessageWidthType.LARGE]: '-large-width'
};

@Component({
    selector: '[flashMessage]',
    templateUrl: './flash-message.component.html',
    styleUrls: ['./flash-message.component.scss'],
    animations: [
        trigger('visibilityState', [
            state('in', style({
                opacity: '0.9'
            })),
            state('leave', style({
                opacity: '0'
            })),
            transition(':enter', [
                style({
                    opacity: '0'
                }),
                animate(FLASH_MESSAGE_ANIMATION_TIME)
            ]),
            // todo: fix it to :leave when bug will be fixed.
            // more info about it: https://github.com/angular/angular/issues/15753
            transition('in => leave', animate(FLASH_MESSAGE_ANIMATION_TIME))
        ])
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FlashMessageComponent implements OnInit, AfterViewInit {

    @Input('flashMessageItem')
    public flashMessageItem: FlashMessage;

    public visibilityState = VisibilityState.in;

    public readonly destroy$ = destroy$();

    public sizeClass: string;

    private popper: PopperInstance;

    constructor(
        private flashMessageElement: ElementRef
    ) {}

    public ngOnInit(): void {
        this.sizeClass = sizeClasses[this.flashMessageItem.widthType];
    }

    public ngAfterViewInit(): void {
        this.initPopper();

        this.flashMessageItem.hide$.pipe(
            takeUntil(this.destroy$)
        ).subscribe(() => this.visibilityState = VisibilityState.leave);
    }

    private initPopper(): void {
        this.popper = createPopper(
            this.flashMessageItem.targetElement,
            this.flashMessageElement.nativeElement,
            {
                placement: 'bottom'
            }
        );

        this.popper.update();

        this.destroy$.subscribe(() => this.popper.destroy());
    }

}
